export default class RwCurrencyController {
  constructor() {
    this.defaultFraction = 0;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-currency/rw-currency-controller.js